import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import LoadingSpin from "components/Loading";
import QuestBlog from "components/QuestBlog";
import ScrollUpBtn from "components/ScrollUpBtn";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListColorQ,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  Detail,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  Line,
  NameCourse,
  SubDetail,
  SubHead,
  SubTitle,
  TextBold,
  TextHead,
  TextName,
  TextNote,
  Title,
  TitleEN,
  View,
} from "./medicine.style";

import stuView from "assets/images/png/student_comp-01.png";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

import handRightIcon from "assets/images/svg/icon-awesome-hand-point-right.svg";

import picMedicine2 from "assets/images/jpg/medicine-2.jpg";
import picMedicine3 from "assets/images/jpg/medicine-3.jpg";
import picMedicine1 from "assets/images/png/medicine-1.png";

function MedicineDepartment({ selectYear, year }) {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=2024`,
      { incrementVisitor: true }
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=2024`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const spliteLinkRegis = (link, text, style) => {
    const newLink = link.split(text);
    return (
      <div className={style !== "" ? `link-web ${style}` : "link-web"}>
        {text}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} minBeYear={2567} />
        </div>
        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>
                            {" "}
                            {breadcrumbName[item]}
                          </Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>
            {windowWidth <= 1280
              ? departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ maxWidth: "104px", width: "100%" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      <div className="col-image-profile">
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.message?.image &&
                              departmentData?.message?.image[0]?.image_0
                            }
                            alt="dean"
                            style={{ marginTop: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      </div>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            ></Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )
              : departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ width: "104px" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            >
                              <FadeInSection axis="y">
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="dean"
                                  width={"100%"}
                                />
                              </FadeInSection>
                            </Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )}
            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      {departmentData?.contract[0]?.department}
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <Href
                            to={item?.slang}
                            rel="noopener noreferrer"
                            target={"_self"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            )}
            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¸žà¸¢à¸²à¸šà¸²à¸¥ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¹à¸žà¸—à¸¢à¹Œà¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}
            {departmentData?.introduct && (
              <Element name={departmentData?.introduct?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    {departmentData?.introduct?.image ? (
                      departmentData?.introduct?.image.map((item) => {
                        return (
                          <FadeInSection axis="y">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                  <Col span={11} offset={1}>
                    <SubTitle>{departmentData?.introduct?.title}</SubTitle>
                    {departmentData?.introduct?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <TextBold bottom="0">{item?.text_0}</TextBold>
                          )}
                          {item?.text_1 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_1}
                            </SubDetail>
                          )}

                          {item?.text_2 && (
                            <TextBold bottom="0">{item?.text_2}</TextBold>
                          )}
                          {item?.text_3 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail bottom="0" top="0">
                              {item?.text_7}
                            </SubDetail>
                          )}
                          {item?.text_8 && (
                            <SubDetail top="0">{item?.text_8}</SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                </Row>
              </Element>
            )}
            {departmentData?.teaching_management &&
              departmentData?.teaching_management_1 && (
                <Element name={departmentData?.teaching_management?.title}>
                  <FixBox bg={ListColor2[slang]}>
                    <SubTitle align="center" top="50">
                      {departmentData?.teaching_management?.title}
                    </SubTitle>

                    <Row gutter={24} className="row-group">
                      <Col span={12}>
                        {departmentData?.teaching_management?.image ? (
                          departmentData?.teaching_management?.image.map(
                            (item) => {
                              return (
                                <FadeInSection axis="y">
                                  <CustomCarousel
                                    autoplay
                                    bg={ListColor1[slang]}
                                  >
                                    {item?.image_0 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_0}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                    {item?.image_1 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_1}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                    {item?.image_2 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_2}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                  </CustomCarousel>
                                </FadeInSection>
                              );
                            }
                          )
                        ) : (
                          <img
                            loading="lazy"
                            src={engineer}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        <SubHead font="Noto Sans Thai Bold" bottom="10">
                          {departmentData?.teaching_management?.title}
                        </SubHead>
                        {departmentData?.teaching_management?.text[0]
                          ?.text_0 && (
                          <>
                            {departmentData?.teaching_management?.text[0]
                              ?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {
                                  departmentData?.teaching_management?.text[0]
                                    ?.text_1
                                }
                              </SubDetail>
                            )}

                            {departmentData?.teaching_management?.text[0]
                              ?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {
                                  departmentData?.teaching_management?.text[0]
                                    ?.text_2
                                }
                              </SubDetail>
                            )}
                            {departmentData?.teaching_management?.text[0]
                              ?.text_3 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {
                                  departmentData?.teaching_management?.text[0]
                                    ?.text_3
                                }
                              </SubDetail>
                            )}
                            {departmentData?.teaching_management?.text[0]
                              ?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {
                                  departmentData?.teaching_management?.text[0]
                                    ?.text_4
                                }
                              </SubDetail>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={12}>
                        {departmentData?.teaching_management_1?.image ? (
                          departmentData?.teaching_management_1?.image.map(
                            (item) => {
                              return (
                                <FadeInSection axis="y">
                                  <CustomCarousel
                                    autoplay
                                    bg={ListColor1[slang]}
                                  >
                                    {item?.image_0 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_0}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                    {item?.image_1 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_1}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                    {item?.image_2 && (
                                      <img
                                        loading="lazy"
                                        src={item?.image_2}
                                        alt="icon group"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                        }}
                                      />
                                    )}
                                  </CustomCarousel>
                                </FadeInSection>
                              );
                            }
                          )
                        ) : (
                          <img
                            loading="lazy"
                            src={engineer}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}

                        <SubHead font="Noto Sans Thai Bold" bottom="10">
                          {departmentData?.teaching_management_1?.title}
                        </SubHead>

                        {departmentData?.teaching_management_1?.text &&
                          departmentData?.teaching_management_1?.text[0]
                            ?.text_0 && (
                            <>
                              <SubDetail top="0" bottom="0" indent="35">
                                {
                                  departmentData?.teaching_management_1?.text[0]
                                    ?.text_0
                                }
                              </SubDetail>

                              {departmentData?.teaching_management_1?.text[0]
                                ?.text_3 && (
                                <SubDetail top="0" bottom="0" indent="35">
                                  {
                                    departmentData?.teaching_management_1
                                      ?.text[0]?.text_1
                                  }
                                </SubDetail>
                              )}

                              {departmentData?.teaching_management_1?.text[0]
                                ?.text_2 && (
                                <SubDetail top="0" bottom="0" indent="35">
                                  {
                                    departmentData?.teaching_management_1
                                      ?.text[0]?.text_2
                                  }
                                </SubDetail>
                              )}
                              {departmentData?.teaching_management_1?.text[0]
                                ?.text_3 && (
                                <SubDetail top="0" bottom="0" indent="35">
                                  {
                                    departmentData?.teaching_management_1
                                      ?.text[0]?.text_3
                                  }
                                </SubDetail>
                              )}
                              {departmentData?.teaching_management_1?.text[0]
                                ?.text_4 && (
                                <SubDetail top="0" bottom="0" indent="35">
                                  {
                                    departmentData?.teaching_management_1
                                      ?.text[0]?.text_4
                                  }
                                </SubDetail>
                              )}
                            </>
                          )}
                      </Col>
                    </Row>
                  </FixBox>
                </Element>
              )}
            {departmentData?.register && (
              <Element name={departmentData?.register?.title}>
                <SubTitle align="center" top="50">
                  {departmentData?.register?.title}
                </SubTitle>

                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    {departmentData?.register?.text[0]?.text_0 && (
                      <SubHead font="Noto Sans Thai Bold" bottom="10">
                        {departmentData?.register?.text[0]?.text_0}
                      </SubHead>
                    )}
                    {departmentData?.register?.text[0]?.text_1 && (
                      <SubDetail top="0" bottom="0">
                        {departmentData?.register?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.register?.text[0]?.text_2 && (
                      <SubDetail top="0" bottom="0">
                        {spliteLinkRegis(
                          departmentData?.register?.text[0]?.text_2,
                          "2) à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¸£à¸²à¸¢à¸§à¸´à¸Šà¸² à¹à¸¥à¸°à¸à¸¥à¸¸à¹ˆà¸¡à¹€à¸£à¸µà¸¢à¸™à¸—à¸µà¹ˆà¸ªà¸²à¸¡à¸²à¸£à¸–à¸¥à¸‡à¹„à¸”à¹‰à¸•à¸²à¸¡à¸ªà¸²à¸‚à¸²à¸§à¸´à¸Šà¸²à¹„à¸”à¹‰à¸—à¸µà¹ˆ ",
                          "medicine"
                        )}
                      </SubDetail>
                    )}
                    {departmentData?.register?.text[0]?.text_3 && (
                      <SubDetail top="0">
                        {spliteLinkRegis(
                          departmentData?.register?.text[0]?.text_3,
                          "3) à¸£à¸°à¸šà¸šà¸—à¸°à¹€à¸šà¸µà¸¢à¸™ ",
                          "medicine"
                        )}
                      </SubDetail>
                    )}
                  </Col>
                  <Col span={12}>
                    {departmentData?.register?.text[0]?.text_4 && (
                      <SubHead font="Noto Sans Thai Bold" bottom="10">
                        {departmentData?.register?.text[0]?.text_4}
                      </SubHead>
                    )}
                    {departmentData?.register?.text[0]?.text_5 && (
                      <SubDetail top="0" bottom="0">
                        {departmentData?.register?.text[0]?.text_5}
                      </SubDetail>
                    )}
                    {departmentData?.register?.text[0]?.text_6 && (
                      <SubDetail top="0" bottom="0">
                        {departmentData?.register?.text[0]?.text_6}
                      </SubDetail>
                    )}
                    {departmentData?.register?.text[0]?.text_7 && (
                      <SubDetail top="0">
                        {departmentData?.register?.text[0]?.text_7}
                      </SubDetail>
                    )}
                  </Col>
                </Row>
              </Element>
            )}
            {departmentData?.nl && (
              <Element name={departmentData?.nl?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      <SubTitle>{departmentData?.nl?.title}</SubTitle>
                      {departmentData?.nl?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail>{item?.text_0}</SubDetail>
                            )}

                            <SubDetail bottom="0" indent="35">
                              <span style={{ color: "#176543" }}>
                                {" "}
                                1. BASIC MEDICAL SCIENCES
                              </span>{" "}
                              à¹€à¸›à¹‡à¸™à¸à¸²à¸£à¸ªà¸­à¸šà¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 1
                              à¹€à¸žà¸·à¹ˆà¸­à¸›à¸£à¸°à¹€à¸¡à¸´à¸™à¸„à¸§à¸²à¸¡à¸£à¸¹à¹‰à¸—à¸²à¸‡à¸”à¹‰à¸²à¸™à¸§à¸´à¸—à¸¢à¸²à¸¨à¸²à¸ªà¸•à¸£à¹Œà¸à¸²à¸£à¹à¸žà¸—à¸¢à¹Œà¸žà¸·à¹‰à¸™à¸à¸²à¸™
                              à¸ªà¸­à¸šà¸•à¸­à¸™à¸ˆà¸šà¸›à¸µ 3 à¸„à¸§à¸²à¸¡à¸£à¸¹à¹‰ pre-clinic à¸¡à¸µà¸ªà¸­à¸šà¸›à¸µà¸¥à¸° 3 à¸„à¸£à¸±à¹‰à¸‡
                            </SubDetail>
                            <SubDetail bottom="0" top="0" indent="35">
                              <span style={{ color: "#176543" }}>
                                2. CLINICAL SCIENCES
                              </span>
                              à¹€à¸›à¹‡à¸™à¸à¸²à¸£à¸ªà¸­à¸šà¸‚à¸±à¹‰à¸™à¸—à¸µà¹ˆ 2
                              à¹€à¸žà¸·à¹ˆà¸­à¸›à¸£à¸°à¹€à¸¡à¸´à¸™à¸„à¸§à¸²à¸¡à¸£à¸¹à¹‰à¸—à¸²à¸‡à¸”à¹‰à¸²à¸™à¸§à¸´à¸—à¸¢à¸²à¸¨à¸²à¸ªà¸•à¸£à¹Œà¸à¸²à¸£à¹à¸žà¸—à¸¢à¹Œà¸„à¸¥à¸´à¸™à¸´à¸
                              à¸ªà¸­à¸šà¸•à¸­à¸™à¸ˆà¸šà¸›à¸µ 5
                            </SubDetail>
                            <SubDetail bottom="20" top="0" indent="35">
                              <span style={{ color: "#176543" }}>
                                3. OBJECTIVE STRUCTURED CLINICAL EXAMINATION :
                                OSCE
                              </span>
                              à¹€à¸›à¹‡à¸™à¸à¸²à¸£à¸ªà¸­à¸šà¸‚à¸±à¹‰à¸™à¸—à¸µà¹ˆ 3
                              à¹€à¸žà¸·à¹ˆà¸­à¸›à¸£à¸°à¹€à¸¡à¸´à¸™à¸—à¸±à¸à¸©à¸°à¹à¸¥à¸°à¸«à¸±à¸•à¸–à¸à¸²à¸£à¸—à¸²à¸‡à¸„à¸¥à¸´à¸™à¸´à¸ à¸ªà¸­à¸šà¸•à¸­à¸™à¸ˆà¸šà¸›à¸µ 6
                            </SubDetail>

                            <TextNote>
                              Note: à¸à¸²à¸£à¸—à¸µà¹ˆà¸ˆà¸°à¸ªà¸­à¸š à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 3
                              à¹„à¸”à¹‰à¸•à¹‰à¸­à¸‡à¸œà¹ˆà¸²à¸™à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 1 à¹à¸¥à¸°à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 2
                              à¹€à¸ªà¸µà¸¢à¸à¹ˆà¸­à¸™à¹à¸•à¹ˆà¸–à¹‰à¸²à¸™à¸±à¸à¸¨à¸¶à¸à¸©à¸²à¹à¸žà¸—à¸¢à¹Œà¸ªà¸­à¸šà¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 1 à¹„à¸¡à¹ˆà¸œà¹ˆà¸²à¸™
                              à¸à¹‡à¸¢à¸±à¸‡à¸ªà¸²à¸¡à¸²à¸£à¸–à¸ªà¸­à¸šà¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 2 à¹„à¸”à¹‰
                              (à¸¢à¸±à¸‡à¸‚à¸¶à¹‰à¸™à¹„à¸›à¹€à¸£à¸µà¸¢à¸™à¸Šà¸±à¹‰à¸™à¸›à¸µ 4 à¹„à¸”à¹‰)
                            </TextNote>
                          </>
                        );
                      })}
                    </Col>
                    <Col span={11} offset={1}>
                      {departmentData?.nl?.image ? (
                        departmentData?.nl?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {departmentData?.nl?.text.map((item) => {
                        return (
                          <>
                            {item?.text_4 && (
                              <SubHead font="Noto Sans Thai Bold" bottom="10">
                                {item?.text_4}
                              </SubHead>
                            )}
                            {item?.text_5 && (
                              <SubDetail bottom="0" top="0" indent="35">
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail bottom="0" top="0" indent="35">
                                {item?.text_6}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail bottom="0" top="0" indent="35">
                                {item?.text_7}
                              </SubDetail>
                            )}
                            {item?.text_8 && (
                              <SubDetail bottom="0" top="0" indent="35">
                                {item?.text_8}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" indent="35">
                                {item?.text_9}
                              </SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}
            {departmentData?.support && (
              <Element name={departmentData?.support?.title}>
                <SubTitle top="50" align="center">
                  {departmentData?.support?.title}
                </SubTitle>
                {departmentData?.support?.text.map((item) => {
                  return (
                    <>
                      <Row gutter={24} className="row-detail-card">
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.support?.image
                                  ? departmentData?.support?.image[0]?.image_0
                                  : picMedicine1
                              }
                              alt="support icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>

                          {item?.text_0 && (
                            <SubHead font="Noto Sans Thai Bold">
                              {item?.text_0}
                            </SubHead>
                          )}
                          <SubDetail>
                            1) à¸—à¸¸à¸™à¹€à¸£à¸µà¸¢à¸™à¸”à¸µ (à¹„à¸”à¹‰à¸£à¸±à¸šà¸¢à¸à¹€à¸§à¹‰à¸™à¸„à¹ˆà¸²à¸«à¸™à¹ˆà¸§à¸¢à¸à¸´à¸•)
                            <div className="link-web">
                              <a
                                href={`https://beta.sut.ac.th/dsa-scholar/wp-content/uploads/sites/183/2021/07/%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8-%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8C-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%97%E0%B8%B8%E0%B8%99.pdf`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u style={{ color: "#176543" }}>
                                  à¹€à¸à¸“à¸‘à¹Œà¸à¸²à¸£à¸¥à¸‡à¸—à¸¸à¸™
                                </u>
                              </a>
                            </div>
                          </SubDetail>
                          <SubDetail>
                            2) à¸—à¸¸à¸™à¸‚à¸²à¸”à¹à¸„à¸¥à¸™à¸—à¸¸à¸™à¸—à¸£à¸±à¸žà¸¢à¹Œ
                            à¹à¸«à¸¥à¹ˆà¸‡à¸—à¸¸à¸™à¸—à¸µà¹ˆà¹„à¸”à¹‰à¸£à¸±à¸šà¸¡à¸²à¸ˆà¸²à¸à¸ à¸²à¸¢à¸™à¸­à¸à¸¡à¸«à¸²à¸§à¸´à¸—à¸¢à¸²à¸¥à¸±à¸¢ à¸ªà¸³à¸™à¸±à¸à¸§à¸´à¸Šà¸²à¸¯
                            à¹€à¸›à¹‡à¸™à¸œà¸¹à¹‰à¸žà¸´à¸ˆà¸²à¸£à¸“à¸²à¹ƒà¸«à¹‰à¸—à¸¸à¸™
                            <div className="link-web">
                              <a
                                href={`https://www.facebook.com/med.scholarship/`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u style={{ color: "#176543" }}>
                                  à¹€à¸Ÿà¸‹à¸šà¸¸à¹Šà¸à¸‡à¸²à¸™à¸—à¸¸à¸™ à¸ªà¸§à¸ž. à¸¡à¸—à¸ª.
                                </u>
                              </a>
                            </div>
                          </SubDetail>
                          <SubDetail>
                            3) à¸à¸­à¸‡à¸—à¸¸à¸™à¹ƒà¸«à¹‰à¸à¸¹à¹‰à¸¢à¸·à¸¡à¹€à¸žà¸·à¹ˆà¸­à¸à¸²à¸£à¸¨à¸¶à¸à¸©à¸² à¸à¸¢à¸¨. à¸à¸£à¸­.
                            à¸”à¸³à¹€à¸™à¸´à¸™à¸à¸²à¸£à¸œà¹ˆà¸²à¸™à¸‡à¸²à¸™à¸—à¸¸à¸™à¸à¸²à¸£à¸¨à¸¶à¸à¸©à¸²à¸‚à¸­à¸‡à¸¡à¸«à¸²à¸§à¸´à¸—à¸¢à¸²à¸¥à¸±à¸¢
                            <div className="link-web">
                              <a
                                href={`https://www.facebook.com/sut.studentloan.fanpage/`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u style={{ color: "#176543" }}>
                                  à¹€à¸Ÿà¸‹à¸šà¸¸à¹Šà¸ à¸à¸¢à¸¨. à¸¡à¸«à¸²à¸§à¸´à¸—à¸¢à¸²à¸¥à¸±à¸¢à¹€à¸—à¸„à¹‚à¸™à¹‚à¸¥à¸¢à¸µà¸ªà¸¸à¸£à¸™à¸²à¸£à¸µ{" "}
                                </u>
                              </a>
                            </div>
                          </SubDetail>
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.support?.image
                                  ? departmentData?.support?.image[0]?.image_1
                                  : picMedicine2
                              }
                              alt="support icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          {item?.text_4 && (
                            <SubHead font="Noto Sans Thai Bold">
                              {item?.text_4}
                            </SubHead>
                          )}
                          {item?.text_5 && (
                            <SubDetail bottom="0">{item?.text_5}</SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          <SubDetail top="0">
                            â€¢ à¸„à¸¥à¸´à¸™à¸´à¸à¸§à¸±à¸¢à¸£à¸¸à¹ˆà¸™ à¸£à¸ž.à¸¡à¸—à¸ª à¹€à¸›à¸´à¸”à¹ƒà¸«à¹‰à¸šà¸£à¸´à¸à¸²à¸£à¸—à¸¸à¸à¸§à¸±à¸™à¸žà¸¤à¸«à¸±à¸ªà¸šà¸”à¸µ
                            à¹€à¸§à¸¥à¸² 13.00-16.00 à¸™.
                            <div className="link-web">
                              <a
                                href={`https://www.facebook.com/people/%E0%B8%84%E0%B8%A5%E0%B8%B4%E0%B8%99%E0%B8%B4%E0%B8%81%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B8%A3%E0%B8%B8%E0%B9%88%E0%B8%99-%E0%B8%A3%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B9%80%E0%B8%97%E0%B8%84%E0%B9%82%E0%B8%99%E0%B9%82%E0%B8%A5%E0%B8%A2%E0%B8%B5%E0%B8%AA%E0%B8%B8%E0%B8%A3%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%B5/100057333614334/`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u style={{ color: "#176543" }}>
                                  à¹€à¸Ÿà¸‹à¸šà¸¸à¹Šà¸ à¸„à¸¥à¸´à¸™à¸´à¸à¸§à¸±à¸¢à¸£à¸¸à¹ˆà¸™
                                  à¸£à¸ž.à¸¡à¸«à¸²à¸§à¸´à¸—à¸¢à¸²à¸¥à¸±à¸¢à¹€à¸—à¸„à¹‚à¸™à¹‚à¸¥à¸¢à¸µà¸ªà¸¸à¸£à¸™à¸²à¸£à¸µ
                                </u>
                              </a>
                            </div>
                          </SubDetail>
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.support?.image
                                  ? departmentData?.support?.image[0]?.image_2
                                  : picMedicine3
                              }
                              alt="support icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          {item?.text_9 && (
                            <SubHead font="Noto Sans Thai Bold">
                              {item?.text_9}
                            </SubHead>
                          )}
                          {item?.text_10 && (
                            <SubDetail bottom="0">{item?.text_10}</SubDetail>
                          )}
                          {item?.text_11 && (
                            <SubDetail top="0">{item?.text_11}</SubDetail>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </Element>
            )}
            {departmentData?.rule && (
              <Element name={departmentData?.rule?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle align="center">
                    {departmentData?.rule?.title}
                  </SubTitle>
                  <Detail color="#176543" align="center">
                    <a
                      href="https://web.sut.ac.th/ces/2018/ces/rules/rules2/med64.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        loading="lazy"
                        src={handRightIcon}
                        alt="icon download file"
                        style={{ margin: "0 20px", height: "32px" }}
                      />
                      <span style={{ fontWeight: "600" }}>
                        à¸”à¸¹à¸£à¸²à¸¢à¸¥à¸°à¹€à¸­à¸µà¸¢à¸”à¸‚à¹‰à¸­à¸šà¸±à¸‡à¸„à¸±à¸šà¸‰à¸šà¸±à¸šà¹€à¸•à¹‡à¸¡
                      </span>
                    </a>
                  </Detail>

                  {departmentData?.rule?.text[0]?.text_1 && (
                    <SubHead font="Noto Sans Thai Bold" bottom="10">
                      {departmentData?.rule?.text[0]?.text_1}
                    </SubHead>
                  )}
                  {departmentData?.rule?.text[0]?.text_2 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_2}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_3 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_3}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_4 && (
                    <SubDetail top="0" bottom="42" indent="35">
                      {departmentData?.rule?.text[0]?.text_4}
                    </SubDetail>
                  )}
                  <div className="line-style">
                    <Line />
                  </div>

                  {departmentData?.rule?.text[0]?.text_5 && (
                    <SubHead font="Noto Sans Thai Bold" top="0" bottom="10">
                      {departmentData?.rule?.text[0]?.text_5}
                    </SubHead>
                  )}
                  {departmentData?.rule?.text[0]?.text_6 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_6}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_7 && (
                    <SubDetail top="0" bottom="42" indent="35">
                      {departmentData?.rule?.text[0]?.text_7}
                    </SubDetail>
                  )}

                  <div className="line-style">
                    <Line />
                  </div>
                  {departmentData?.rule?.text[0]?.text_8 && (
                    <SubHead font="Noto Sans Thai Bold" top="0" bottom="10">
                      {departmentData?.rule?.text[0]?.text_8}
                    </SubHead>
                  )}
                  <SubDetail top="0" bottom="0" indent="35">
                    â€¢ à¸à¸²à¸£à¸ªà¸­à¸šà¸›à¸£à¸°à¸à¸­à¸šà¸”à¹‰à¸§à¸¢ 2 à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™
                  </SubDetail>
                  <SubDetail top="0" bottom="0" indent="55">
                    - à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 1 à¸„à¸§à¸²à¸¡à¸£à¸¹à¹‰à¸—à¸²à¸‡à¸§à¸´à¸—à¸¢à¸²à¸¨à¸²à¸ªà¸•à¸£à¹Œà¸à¸²à¸£à¹à¸žà¸—à¸¢à¹Œà¸žà¸·à¹‰à¸™à¸à¸²à¸™
                  </SubDetail>
                  <SubDetail top="0" bottom="0" indent="55">
                    - à¸‚à¸±à¹‰à¸™à¸•à¸­à¸™à¸—à¸µà¹ˆ 2 à¸„à¸§à¸²à¸¡à¸£à¸¹à¹‰à¸—à¸²à¸‡à¸§à¸´à¸—à¸¢à¸²à¸¨à¸²à¸ªà¸•à¸£à¹Œà¸à¸²à¸£à¹à¸žà¸—à¸¢à¹Œà¸Šà¸±à¹‰à¸™à¸„à¸¥à¸´à¸™à¸´à¸
                  </SubDetail>
                  {departmentData?.rule?.text[0]?.text_10 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_10}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_11 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_11}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_12 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_12}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_13 && (
                    <SubDetail top="0" bottom="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_13}
                    </SubDetail>
                  )}
                  {departmentData?.rule?.text[0]?.text_14 && (
                    <SubDetail top="0" indent="35">
                      {departmentData?.rule?.text[0]?.text_14}
                    </SubDetail>
                  )}
                </FixBox>
              </Element>
            )}
            {departmentData?.question && (
              <Element name={departmentData?.question?.title}>
                <SubTitle>{departmentData?.question?.title}</SubTitle>

                {departmentData?.question?.type &&
                  departmentData?.question?.type.length >= 0 &&
                  departmentData?.question?.type.map((item, index, row) => {
                    return (
                      <div key={`title-${index}`}>
                        <Row className="row-top">
                          <Col span={24}>
                            {item?.title && <TextHead>{item?.title}</TextHead>}
                          </Col>
                          <Col span={24}>
                            {item?.question.length >= 0 &&
                              item?.question.map((item, index) => {
                                return (
                                  <QuestBlog
                                    colorQuest={ListColorQ[slang]}
                                    top="40"
                                    key={`quest-${index}`}
                                    headText={item?.question}
                                    ansTextFirst={
                                      item?.answers ? item?.answers : ""
                                    }
                                    ansTextSecon={
                                      item?.answer_1 ? item?.answer_1 : ""
                                    }
                                    ansTextThird={
                                      item?.answer_2 ? item?.answer_2 : ""
                                    }
                                  />
                                );
                              })}
                          </Col>
                        </Row>
                        {index + 1 !== row.length && (
                          <div className="line-style">
                            <Line />
                          </div>
                        )}
                      </div>
                    );
                  })}
              </Element>
            )}
            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"white"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                            return (
                              <Col
                                span={12}
                                style={{ padding: "10px" }}
                                key={index}
                              >
                                <div style={styleDetailContact}>
                                  <DetailContact
                                    color="var(--black)"
                                    title={item?.title}
                                    phone={item?.phone_1}
                                    office={item?.phone_2}
                                    facebook={item?.fb}
                                    website={item?.site}
                                    email1={item?.email_1}
                                    email2={item?.email_2}
                                    email3={item?.email_3}
                                    line={item?.line}
                                    indent={"40"}
                                    slang={slang}
                                    type="branch"
                                  />
                                </div>
                              </Col>
                            );
                          })
                        : contactData[0]?.address !== "" && (
                            <Col span={12} style={{ padding: "10px" }}>
                              <DetailContact
                                color="var(--black)"
                                title={contactData[0]?.title}
                                address={contactData[0]?.address}
                                slang={slang}
                                type="branch"
                              />
                            </Col>
                          )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}
            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>à¸•à¸±à¹‰à¸‡à¹à¸•à¹ˆà¹€à¸£à¸´à¹ˆà¸¡à¹€à¸›à¸´à¸”à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œ</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>à¸›à¸µ (à¸ž.à¸¨.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
}

export default MedicineDepartment;
